export default __webpack_public_path__ + "static/media/sudhanshu.1e2c7ed3.jpeg";